export const durchschnitt = {
    DurchschnittimJahrClass: {
        url: "RegioDurchschnitt/imJahr",
        defaultSegment: "RegioDurchschnitt",
        forceRefresh: false,
        receiveType: 'RECEIVE_BarDiagrammDurchschnitt_durchschnittReducer'
    },
    DurchschnittimJahrUpdateClass: {
        url: "RegioDurchschnitt?type=1",
        defaultSegment: "RegioDurchschnitt",
        post: true,
        forceRefresh: false,
        receiveType: 'RECEIVE_BarDiagrammDurchschnittUpdate_durchschnittReducer'
    },
    DurchschnittimJahrUpdateResetClass: {
        receiveType: 'RESET_BarDiagrammDurchschnittUpdate_durchschnittReducer'
    }
};